import { SshCategoryActions } from "@dots-crm/contracts/client";

export const SSH_CATEGORY_ENDPOINTS_URLS = {
  create: "ssh-category",
  readMany: "ssh-category",
  readAvailable: "ssh-category/available",
  readOne: ({ categoryId }: SshCategoryActions["readOne"]["params"]) =>
    `ssh-category/${categoryId}`,
  update: ({ categoryId }: SshCategoryActions["update"]["params"]) =>
    `ssh-category/${categoryId}`,
  delete: ({ categoryId }: SshCategoryActions["delete"]["params"]) =>
    `ssh-category/${categoryId}`,
};

export const SSH_CATEGORY_TAGS = {
  sshCategory: "sshCategory",
};
